import React from 'react';
import CardsList from '../components/CardsList';
import { buscarCorSLA } from '../rules/regraSLA';

/**
 * Esconde parte do nome, mostrando apenas
 * o último nome e a inicial do primeiro.
 * Exemplo: "João da Silva" → "Silva, J"
 */
export const esconderNome = (nome) => {
	const nomeTrim = (nome || '').trim();
	let nomeFormatado = '';
	if (nomeTrim.length > 1) {
		const partes = nomeTrim.split(' ').filter(Boolean);
		const primeiro = partes[0] || '';
		const ultimo = partes[partes.length - 1] || '';
		nomeFormatado = `${ultimo}, ${primeiro[0] || ''}`;
	}

	return nomeFormatado;
};

/**
 * Converte minutos em formato de tempo HH:MM:SS.
 * Aceita minutos inteiros ou decimais.
 * Exemplo: 90 → "01:30:00"
 * Exemplo: 5.5 → "00:05:30"
 */
export const formatarTempo = (minutos) => {
	const totalSegundos = minutos * 60;
	const horas = Math.floor(totalSegundos / 3600);
	const minutosRestantes = Math.floor((totalSegundos % 3600) / 60);
	const segundos = totalSegundos % 60;

	const hh = String(horas).padStart(2, '0');
	const mm = String(minutosRestantes).padStart(2, '0');
	const ss = String(segundos).padStart(2, '0');

	// return `${hh}:${mm}:${ss}`;
	return `${horas}h${mm}m`;

};

/**
 * Monta as informações consolidadas dos cards da tela inicial
 * a partir dos dados detalhados retornados pela API.
 */
export const montarInfoCards = (dataDetalhada) => {
	const dados = dataDetalhada ?? {};
	const infoCards = {};
	CardsList.forEach((card) => {
		const dataPacientes = dados[card.tipo] ?? [];
		const pacientesAdulto = dataPacientes.filter((item) => !card.regras.isPediatria(item));
		const pacientesInfantil = dataPacientes.filter((item) => card.regras.isPediatria(item));

		// Medicação
		const pacientesDispensacao = dataPacientes.filter((item) => item.AGUARDANDO === 'Dispensação');
		const pacientesChecagem = dataPacientes.filter((item) => item.AGUARDANDO === 'Checagem');

		// Exames Laboratoriais/Imagem
		const pacientesColeta = dataPacientes.filter((item) => item.TIPO === 'COLETA');
		const pacientesLaudo = dataPacientes.filter((item) => item.TIPO === 'LAUDO');

		// Internação
		const pacientesAutorizacao = dataPacientes.filter((item) => item.SITUACAO === 'Aguardando Autorização');
		const pacientesLeitoExtra = dataPacientes.filter((item) => item.SITUACAO !== 'Aguardando Autorização');

		let arrCoresAdulto = [];
		pacientesAdulto.forEach(paciente => {
			arrCoresAdulto.push(buscarCorSLA({ tipoCard: card.tipo, tempo: (paciente?.VALOR ?? 0), pulseira: paciente.NOMECOR, tipoExame: paciente.TIPO, situacao: paciente.SITUACAO, tipoMedicacao: paciente.AGUARDANDO, tipoPaciente: 'adulto' }));
		});

		let arrCoresInfantil = [];
		pacientesInfantil.forEach(paciente => {
			arrCoresInfantil.push(buscarCorSLA({ tipoCard: card.tipo, tempo: (paciente?.VALOR ?? 0), pulseira: paciente.NOMECOR, tipoExame: paciente.TIPO, situacao: paciente.SITUACAO, tipoMedicacao: paciente.AGUARDANDO, tipoPaciente: 'infantil' }));
		});

		let corAdulto = 'VERDE';
		if (arrCoresAdulto.includes('VERMELHO')) {
			corAdulto = 'VERMELHO';
		} else if (arrCoresAdulto.includes('AMARELO')) {
			corAdulto = 'AMARELO';
		}

		let corInfantil = 'VERDE';
		if (arrCoresInfantil.includes('VERMELHO')) {
			corInfantil = 'VERMELHO';
		} else if (arrCoresInfantil.includes('AMARELO')) {
			corInfantil = 'AMARELO';
		}

		let pacienteMaiorTempo = {};
		let pacienteMaiorTempoTriagem = {};
		let pacienteMaiorTempoDispensacao = {};
		let pacienteMaiorTempoChecagem = {};
		let pacienteMaiorTempoColeta = {};
		let pacienteMaiorTempoLaudo = {};
		let pacienteMaiorTempoAutorizacao = {};
		let pacienteMaiorTempoLeitoExtra = {};

		if (dataPacientes.length >= 1) {
			pacienteMaiorTempo = dataPacientes.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);

			pacienteMaiorTempoTriagem = dataPacientes.reduce(
				(a, b) => Number(a.VALORTRIAGEM) > Number(b.VALORTRIAGEM) ? a : b
			);
		}

		if (pacientesDispensacao.length >= 1) {
			pacienteMaiorTempoDispensacao = pacientesDispensacao.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesChecagem.length >= 1) {
			pacienteMaiorTempoChecagem = pacientesChecagem.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesColeta.length >= 1) {
			pacienteMaiorTempoColeta = pacientesColeta.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesLaudo.length >= 1) {
			pacienteMaiorTempoLaudo = pacientesLaudo.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesAutorizacao.length >= 1) {
			pacienteMaiorTempoAutorizacao = pacientesAutorizacao.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesLeitoExtra.length >= 1) {
			pacienteMaiorTempoLeitoExtra = pacientesLeitoExtra.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		const maiorTempo = pacienteMaiorTempo?.VALOR ?? 0;
		const maiorTempoTriagem = pacienteMaiorTempoTriagem?.VALORTRIAGEM ?? 0;
		const maiorTempoDispensacao = pacienteMaiorTempoDispensacao?.VALOR ?? 0;
		const maiorTempoChecagem = pacienteMaiorTempoChecagem?.VALOR ?? 0;
		const maiorTempoColeta = pacienteMaiorTempoColeta?.VALOR ?? 0;
		const maiorTempoLaudo = pacienteMaiorTempoLaudo?.VALOR ?? 0;
		const maiorTempoAutorizacao = pacienteMaiorTempoAutorizacao?.VALOR ?? 0;
		const maiorTempoLeitoExtra = pacienteMaiorTempoLeitoExtra?.VALOR ?? 0;

		const tipoPacienteMaiorTempo = card.regras.isPediatria(pacienteMaiorTempo) ? 'infantil' : 'adulto';

		infoCards[card.tipo] = {
			totalPacientes: dataPacientes.length,
			totalAdulto: pacientesAdulto.length,
			totalInfantil: pacientesInfantil.length,
			totalDispensacao: pacientesDispensacao.length,
			totalChecagem: pacientesChecagem.length,
			totalColeta: pacientesColeta.length,
			totalLaudo: pacientesLaudo.length,
			totalAutorizacao: pacientesAutorizacao.length,
			totalLeitoExtra: pacientesLeitoExtra.length,

			maiorTempo: formatarTempo(maiorTempo),
			maiorTempoTriagem: formatarTempo(maiorTempoTriagem),
			maiorTempoDispensacao: formatarTempo(maiorTempoDispensacao),
			maiorTempoChecagem: formatarTempo(maiorTempoChecagem),
			maiorTempoColeta: formatarTempo(maiorTempoColeta),
			maiorTempoLaudo: formatarTempo(maiorTempoLaudo),
			maiorTempoAutorizacao: formatarTempo(maiorTempoAutorizacao),
			maiorTempoLeitoExtra: formatarTempo(maiorTempoLeitoExtra),

			corAdulto: corAdulto,
			corInfantil: corInfantil,

			corMaiorTempo: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempo,
				pulseira: pacienteMaiorTempo.NOMECOR,
				tipoExame: pacienteMaiorTempo.TIPO,
				situacao: pacienteMaiorTempo.SITUACAO,
				tipoMedicacao: pacienteMaiorTempo.AGUARDANDO,
				tipoPaciente: tipoPacienteMaiorTempo,
			}),

			corMaiorTempoTriagem: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoTriagem,
			}),

			corMaiorTempoDispensacao: buscarCorSLA({
				tipoCard: card.tipo,
				tipoMedicacao: pacienteMaiorTempoDispensacao.AGUARDANDO,
				tempo: maiorTempoDispensacao,
			}),

			corMaiorTempoChecagem: buscarCorSLA({
				tipoCard: card.tipo,
				tipoMedicacao: pacienteMaiorTempoChecagem.AGUARDANDO,
				tempo: maiorTempoChecagem,
			}),

			corMaiorTempoColeta: buscarCorSLA({
				tipoCard: card.tipo,
				tipoExame: pacienteMaiorTempoColeta.TIPO,
				pulseira: pacienteMaiorTempoColeta.NOMECOR,
				tempo: maiorTempoColeta,
			}),

			corMaiorTempoLaudo: buscarCorSLA({
				tipoCard: card.tipo,
				tipoExame: pacienteMaiorTempoLaudo.TIPO,
				pulseira: pacienteMaiorTempoLaudo.NOMECOR,
				tempo: maiorTempoLaudo,
			}),

			corMaiorTempoAutorizacao: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoAutorizacao,
			}),

			corMaiorTempoLeitoExtra: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoLeitoExtra,
			}),
		};
	})

	return infoCards;
};

/**
 * Monta os dados da busca de pacientes a partir do retorno detalhado da API.
 */
const derivarSituacao = (tipoCard, paciente) => {
	switch (Number(tipoCard)) {
		case 1: // Triagem
			return paciente.SITUACAO ?? null;
		case 2: // Cadastro
			if (paciente.SITUACAO === 'Aguardando Atendimento') return 'Aguard. Atendimento';
			return paciente.SITUACAO ?? null;
		case 3: // Atendimento Médico
			return paciente.AGUARDANDO ?? null;
		case 4: // Reavaliação Médica
			return null;
		case 5: // Medicação
			return paciente.AGUARDANDO ?? null;
		case 6: // Exames Laboratoriais
			return paciente.TIPO === 'COLETA' ? 'Coleta' : 'Laudo';
		case 7: // Exames de Imagem
			return paciente.TIPO === 'COLETA' ? 'Exame' : 'Laudo';
		case 8: // Internação
			if (paciente.SITUACAO === 'Aguardando Internação') return 'Aguard. Internação';
			if (paciente.SITUACAO === 'Aguardando Autorização') return 'Aguard. Autorização';
			return paciente.SITUACAO ?? null;
		default:
			return paciente.AGUARDANDO ?? paciente.SITUACAO ?? null;
	}
};

export const montarDadosPacientes = (dataDetalhada) => {
	const dadosPacientes = {};

	Object.entries(dataDetalhada).forEach(([index, lista]) => {
		lista.forEach(paciente => {
			const codigoPaciente = paciente?.CODIGOPACIENTE ?? '';
			const codigoAtendimento = paciente?.CODIGOATENDIMENTO ?? '';
			const nomePaciente = paciente?.NOMEPACIENTE ?? '';
			const corPulseira = paciente?.NOMECOR ?? '';
			const nomeSolicitante = paciente?.NOMESOLICITANTE ?? '';
			const especialidade = paciente?.DESCRICAOESPECIALIDADE ?? '';

			if (!codigoPaciente) return;

			// dados gerais
			if (!dadosPacientes[codigoPaciente]) {
				dadosPacientes[codigoPaciente] = {
					CODIGOPACIENTE: codigoPaciente,
					CODIGOATENDIMENTO: codigoAtendimento,
					NOMEPACIENTE: nomePaciente,
					NOMECOR: corPulseira,
					NOMESOLICITANTE: nomeSolicitante,
					DESCRICAOESPECIALIDADE: especialidade,
					LABELPROTOCOLO: cardProtocolo(paciente?.DOCUMENTOCLINICO),
					LABELCATEGORIA: cardCategoriaPaciente(paciente?.CATEGORIAPACIENTE),
					PROCESSOS: new Set()
				};
			}

			// dados dos processos
			const tituloProcesso = CardsList.find(card => card.tipo == index)?.title;
			if (tituloProcesso) {
				dadosPacientes[codigoPaciente].PROCESSOS.add({
					PROCESSO: tituloProcesso,
					AGUARDANDO: derivarSituacao(index, paciente),
					ESPERA: paciente.VALOR,
					ESPERATOTAL: paciente.VALORTRIAGEM,
					COR: buscarCorSLA({
						tipoCard: index,
						tempo: paciente.VALOR,
						pulseira: corPulseira,
						tipoExame: paciente.TIPO,
						situacao: paciente.SITUACAO,
						tipoMedicacao: paciente.AGUARDANDO,
					}),
				});
			}
		});
	});

	return Object.values(dadosPacientes).map(item => ({
		...item,
		PROCESSOS: Array.from(item.PROCESSOS)
	}));
};

export const cardProtocolo = (protocolo) => {
	let labelProtcolo = '';
	if (protocolo && protocolo.trim().length > 0 && protocolo.trim() !== 'OUTROS') {
		labelProtcolo = (
			<span style={{
				backgroundColor: '#EF3D5F',
				color: 'white',
				fontWeight: 'bold',
				padding: '4px 4px',
				marginLeft: '8px',
				verticalAlign: 'middle',
				borderRadius: '4px',
				fontSize: '1.3rem',
				whiteSpace: 'nowrap',
				cursor: 'default'
			}}>
				{
					(() => {
						const trimmed = protocolo.trim();
						switch (trimmed) {
							case 'OUTROS':
								return '';
							case 'DOR_TORACICA':
								return 'DOR TORÁCICA';
							case 'SEPSE':
								return 'SEPSE';
							default:
								return trimmed.toUpperCase();
						}
					})()
				}
			</span>
		);
	}

	return labelProtcolo;
};

export const cardCategoriaPaciente = (categoria) => {
	let labelCategoria = '';
	if (categoria && categoria.trim().length > 0 && categoria.trim() !== '') {
		let bgColor = null;
		if (categoria == 'Oncológico') {
			bgColor = '#FEC30A';
		} else if (categoria == 'VIP') {
			bgColor = '#9800B7';
		}
		labelCategoria = (
			<span style={{
				backgroundColor: bgColor,
				color: 'white',
				fontWeight: 'bold',
				padding: '4px 4px',
				marginLeft: '8px',
				verticalAlign: 'middle',
				borderRadius: '4px',
				fontSize: '1.3rem',
				whiteSpace: 'nowrap',
				cursor: 'default'
			}}>
				{
					(() => {
						const trimmed = categoria.trim();
						return trimmed;
					})()
				}
			</span>
		);
	}

	return labelCategoria;
};

export const cardProbabilidadeInternacao = (porcentagem, fontSize = '1.3rem') => {
	let labelProbabilidade = '';
	if (porcentagem != null) {
		labelProbabilidade = (
			<span 
				data-toggle="tooltip" 
				title="Probabilidade de Internação"
				style={{
					backgroundColor: '#d4d4d4',
					color: '#4d4d4d',
					padding: '4px 4px',
					marginLeft: '8px',
					verticalAlign: 'middle',
					borderRadius: '4px',
					fontSize: fontSize,
					whiteSpace: 'nowrap',
					cursor: 'default'
				}}>{porcentagem + '%'}
			</span>
		);
	}

	return labelProbabilidade;
};

export const camelCase = (str) => {
	let camelStr = str.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ');
	camelStr = camelStr
		.split('/')
		.map(part => part.trim().split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' '))
		.join(' / ');
	// manter as preposições em minúsculo
	camelStr = camelStr.replace(/ De /g, ' de ').replace(/ Da /g, ' da ').replace(/ Do /g, ' do ').replace(/ E /g, ' e ');

	// abrevia os nomes do meio exceto as preposições
	camelStr = camelStr.split(' / ').map(part => {
		return part.split(' ').map((word, idx, arr) => {
			if (idx !== 0 && idx !== arr.length - 1 && !['de', 'da', 'do', 'e'].includes(word.toLowerCase())) {
				return word.charAt(0) + '.';
			}
			return word;
		}).join(' ');
	}).join(' / ');

	return camelStr;
};